module.exports = __webpack_public_path__ + "static/img/rooftop page top img_desktop.69fc7f49.jpg";